import { useEffect, useState } from "react";
import api from "./api";

export const REGIMENES = [
  ["601", "General de Ley Personas Morales"], ["603", "Personas Morales con Fines no Lucrativos"],
  ["605", "Sueldos y Salarios"], ["606", "Arrendamiento"], ["607", "Enajenación o Adquisición de Bienes"],
  ["608", "Demás ingresos"], ["610", "Residentes en el Extranjero"], ["611", "Dividendos"],
  ["612", "Personas Físicas con Actividades Empresariales y Profesionales"], ["614", "Ingresos por intereses"],
  ["615", "Obtención de premios"], ["616", "Sin obligaciones fiscales"], ["620", "Sociedades Cooperativas de Producción"],
  ["621", "Incorporación Fiscal"], ["622", "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"],
  ["623", "Opcional para Grupos de Sociedades"], ["624", "Coordinados"], ["625", "Plataformas Tecnológicas"],
  ["626", "Régimen Simplificado de Confianza"],
];

export const USOS_CFDI = [
  ["G01", "Adquisición de mercancías"], ["G03", "Gastos en general"], ["I01", "Construcciones"],
  ["D01", "Honorarios médicos"], ["CP01", "Pagos"], ["S01", "Sin efectos fiscales"],
];

export const FORMAS_PAGO = [["01", "Efectivo"], ["03", "Transferencia"], ["04", "Tarjeta de crédito"], ["28", "Tarjeta de débito"], ["02", "Cheque"]];

export const MOTIVOS_CANCELACION = [
  ["02", "02 · Comprobante emitido con errores sin relación"],
  ["01", "01 · Comprobante emitido con errores con relación (requiere UUID sustituto)"],
  ["03", "03 · No se llevó a cabo la operación"],
  ["04", "04 · Operación nominativa relacionada en una factura global"],
];

export const TAX_TYPES = [["iva16", "IVA 16%"], ["tasa0", "IVA tasa 0%"], ["exento", "Exento de IVA"]];

export const PERIODICIDAD = [["01", "Diario"], ["02", "Semanal"], ["03", "Quincenal"], ["04", "Mensual"], ["05", "Bimestral"]];

export const EMPTY_CLIENT = { rfc: "", legal_name: "", fiscal_regime: "616", cfdi_use: "G03", tax_zip: "", email: "", phone: "" };

let _cache = null;
let _at = 0;
let _pending = null;
export function fetchInvoicingStatus(force = false) {
  if (_cache && !force && Date.now() - _at < 30000) return Promise.resolve(_cache);
  if (_pending && !force) return _pending;
  _pending = api.get("/invoicing/status")
    .then((r) => { _cache = r.data; _at = Date.now(); return _cache; })
    .catch(() => { _cache = { enabled: false, plan_ok: false }; return _cache; })
    .finally(() => { _pending = null; });
  return _pending;
}

export function useInvoicing(force = false) {
  const [st, setSt] = useState(_cache || { enabled: false, plan_ok: false });
  useEffect(() => {
    let alive = true;
    fetchInvoicingStatus(force).then((s) => { if (alive) setSt(s); });
    return () => { alive = false; };
  }, [force]);
  return st;
}

export function openInvoice(detail) {
  window.dispatchEvent(new CustomEvent("open-invoice", { detail }));
}

export async function downloadInvoiceFile(inv, fmt) {
  const { data } = await api.get(`/invoicing/invoices/${inv.id}/file/${fmt}`);
  const bin = atob(data.content || "");
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: data.content_type }));
  const a = document.createElement("a");
  a.href = url; a.download = data.filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const invoiceLabel = (inv) => `${inv.serie}-${inv.folio}`;
